import { createContext, useContext } from 'react';

// The path prefix this app is mounted under when federated into a host shell
// (e.g. '/change-management'). Empty string when running standalone at the
// domain root, where absolute links already point to the right place.
const ModulePathContext = createContext<string>('');

export const ModulePathProvider = ModulePathContext.Provider;

export function useModulePath(): string {
  return useContext(ModulePathContext);
}
